export const MAX_UPLOAD_FILE_SIZE_BYTES = 10 * 1024 * 1024;

const FILE_SIZE_LIMIT_SUFFIX_KEY = '(МАКСИМАЛЬНЫЙ ОБЪЕМ ФАЙЛА НЕ ДОЛЖЕН ПРЕВЫШАТЬ 10 МБ)';

export function buildFileSectionTitle(t, titleKey) {
	return `${t(titleKey)} ${t(FILE_SIZE_LIMIT_SUFFIX_KEY)}`;
}

export function createFileSizeRule(t) {
	return (file) => !file || file.size < MAX_UPLOAD_FILE_SIZE_BYTES
		|| t('Размер файла не должен превышать 10 Мб');
}
